import { useTranslation } from "react-i18next";
import { AppShell } from "../components/layout/AppShell";
import { useCachedResource } from "../hooks/useCachedResource";
import { myWallet, walletTransactions } from "../api/wallet";
import { BalanceCard } from "../features/wallet/BalanceCard";
import { UsageStats } from "../features/wallet/UsageStats";
import { PackagePicker } from "../features/wallet/PackagePicker";
import { AutoTopup } from "../features/wallet/AutoTopup";
import { TxnList } from "../features/wallet/TxnList";

export default function WalletPage() {
  const { t } = useTranslation();
  const { data } = useCachedResource("wallet", async () => {
    const [summary, ledger] = await Promise.all([myWallet(), walletTransactions()]);
    return { wallet: summary, txns: ledger };
  });
  const wallet = data?.wallet || null;
  const txns = data?.txns || [];

  return (
    <AppShell title={t("wallet.title")} subtitle={t("wallet.subtitle")}>
      {!wallet ? (
        <p className="text-sm text-muted-foreground">{t("app.loading")}</p>
      ) : (
        <div className="grid gap-6" data-testid="wallet-page">
          <UsageStats wallet={wallet} />
          <AutoTopup />
          <div className="grid gap-6 lg:grid-cols-[minmax(0,320px)_minmax(0,1fr)]">
            <BalanceCard wallet={wallet} />
            <PackagePicker wallet={wallet} />
          </div>
          <TxnList items={txns} />
        </div>
      )}
    </AppShell>
  );
}
